import { NavLink } from "react-router-dom";

const TABS = [
  { label: "인사말", to: "/about/greeting" },
  { label: "연혁", to: "/about/history" },
  { label: "임원", to: "/about/officers" },
];

// 클럽소개 하위 메뉴 전환용 세그먼트 탭
export default function AboutTabs() {
  return (
    <div className="mx-auto max-w-6xl px-4 md:px-6 pt-8">
      <div className="inline-flex items-center gap-1 rounded-full border border-background-200 bg-background-100 p-1">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:text-primary-700"
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}